/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

// index page sections


import InjectedRegisterBillingForm from "./CheckoutForm";
import {RiTeamLine, RiUser3Line} from "react-icons/ri";
import {getStats} from "../../components/helpers/StatsHelpers";
import withNavigationHook from "../../hooks/withNavigationHook";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";
import {FALLBACK_PRICES, formatPrice, getSubscriptionPrices} from "../../components/helpers/PricingHelpers";

class RegisterBilling extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      prices: FALLBACK_PRICES,
      pricesLoading: true,
    };
    getStats.call(this);
  }

  componentDidMount() {
    getSubscriptionPrices().then(prices => {
      this.setState({prices, pricesLoading: false});
    });

    if (!sessionStorage.getItem("selectedPlan")) {
      this.props.navigation("/register/choose-your-plan");
      return;
    }

    if (typeof window.gtag === 'function') {
      const storedPlan = sessionStorage.getItem("selectedPlan");
      if (!["month", "year"].includes(storedPlan)) return;

      const plan = storedPlan === "month" ? "monthly" : "annual";

      window.gtag('event', 'add_payment_info', {
        plan
      });
    }
  }

  render() {
    const selectedAccountType = sessionStorage.getItem("selectedAccountType");
    const isTeam = selectedAccountType === "team";
    const isEnterprise = selectedAccountType === "enterprise";
    const accountLabel = isEnterprise ? "Organisation" : (isTeam ? "Team" : "Single User");
    const pricePence = isEnterprise
        ? this.state.prices.enterprise.annual
        : (isTeam
            ? this.state.prices.group.annual
            : (sessionStorage.getItem("selectedPlan") === "month"
                ? this.state.prices.individual.monthly
                : this.state.prices.individual.annual));
    const price = this.state.pricesLoading ? "Loading..." : formatPrice(pricePence);

    return (
      <>
        <SeoNoIndex noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>billing</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                Subscription
                              </h2>
                            </Col>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase text-right">
                              </h2>
                            </Col>
                          </Row>
                          <Row style={{border:'2px', solid: '#3498db', borderRadius: '15px', padding: '20px', margin: '20px', backgroundColor: '#ecf0f1'}}>
                            <Col lg="2" style={{textAlign:'center'}}>
                              {isTeam || isEnterprise
                                  ? <><RiTeamLine color='#0570de' size="36"/><br/>{accountLabel}</>
                                  : <><RiUser3Line color='#0570de' size="36"/><br/>Single User</>
                              }
                            </Col>
                            <Col>
                              You can build, save and edit unlimited curated song-flows using all of our
                              {" "}{!sessionStorage.getItem("statsTtl") || JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value === 0 ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value}{" "}
                              song books.
                              <Col lg="12" style={{textAlign:'center', fontSizeAdjust:'0.45'}}>
                                <br/>You can manage your subscription in your profile
                              </Col>
                            </Col>
                            <Col lg="3" style={{textAlign:'center'}}>
                              { sessionStorage.getItem("couponCode") &&
                                  <>
                                    Payment will <strong>not</strong> be taken now, but payment details are required to set up your account.
                                  </>
                              }
                              { !sessionStorage.getItem("couponCode") &&
                                  <>
                                    {price}<br/>
                                    per {sessionStorage.getItem("selectedPlan") === "month" ? <>month</> : <>year</>}
                                  </>
                              }
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              &nbsp;
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                Payment Details
                              </h2>
                            </Col>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase text-right">
                              </h2>
                            </Col>
                          </Row>
                          <InjectedRegisterBillingForm/>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default withNavigationHook(RegisterBilling);
